import React from 'react';

const defaultValues = {
  boardFiltersValues: [],
  setBoardFiltersValues: (e) => {},
}

const BoardsCtx = React.createContext(defaultValues);

export default BoardsCtx;